import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Slide from "@material-ui/core/Slide";
import DynamicRoutingAnimation from "../../../DialogAnimations/DynamicRoutingAnimation";
import * as MergingRoutesAnimation from "../../../DialogAnimations/MergingRoutesAnimation.json";
import * as ReadingDataAnimation from "../../../DialogAnimations/ReadingDataAnimation.json";
import * as BuildingRoutesAnimation from "../../../DialogAnimations/BuildingRoutesAnimation.json";
import * as SuccessAnimation from "../../../DialogAnimations/SuccessAnimation.json";

const styles = theme => ({
    container: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%"
    },
    textboxBold: {
        fontWeight: '600',
        fontSize: '36px',
        lineHeight: '49px',
        textAlign: "center",
        color: theme.HeaderSelectedText
    },
    instructions: {
        marginTop: '25px'
    },
    percentageComplete: {
        padding: "24px 0px",
        textAlign: "center",
        fontStyle: "italic",
        color: theme.gridTextColor,
        lineHeight: "22px"
    },
    didYouKnowTitle: {
        textAlign: "center",
        fontWeight: 600,
        lineHeight: "22px",
        color: theme.HeaderSelectedText,
        paddingTop: "24px"
    },
    factsWrapper: {
        color: theme.gridTextColor,
        textAlign: "center",
        fontStyle: "italic",
        lineHeight: "34px",
        padding: "12px 0px"
    }
})
class OptimizationLoader extends React.Component {
    constructor(props) {
        super(props);
        this.didYouKnowText = "You can sequence all the stops by clicking on the sequence optimizer icon on the Routes Grid"
    }
    updateAnimation = progress => {
        if (this.props.isCompleted) {
            return {
                animationText: "Success",
                animationData: SuccessAnimation.default
            };
        } else {
            if (progress === 0) {
                return {
                    animationText: "Job Queued",
                    animationData: ReadingDataAnimation.default
                };
            } else if (progress <= 30) {
                return {
                    animationText: "Reading Data",
                    animationData: ReadingDataAnimation.default
                };
            } else if (progress > 30 && progress <= 60) {
                return {
                    animationText: "Building Routes",
                    animationData: BuildingRoutesAnimation.default
                };
            } else {
                return {
                    animationText: "Merging Routes",
                    animationData: MergingRoutesAnimation.default
                };
            }
        }
    };
    render() {
        const { classes, progressPercentage } = this.props;
        const { animationData } = this.updateAnimation(
            progressPercentage
        );
        return (
            <div className={classes.container}>
                <div className={classes.textboxBold}>Assigning pickups to drivers</div>
                <div className={classes.instructions}>
                    <div>
                        <DynamicRoutingAnimation
                            dimension={250}
                            animationJSON={animationData}
                        />
                        <div className={classes.didYouKnowTitle}>Did You Know?</div>
                        <div className={classes.factsWrapper}>
                            <Slide direction="right" in={true}>
                                <div>{this.didYouKnowText}</div>
                            </Slide>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(OptimizationLoader);